import React from 'react'
import NorthstarHubComp from './NorthstarHubComp'

function StartupCornerComp() {
  return <NorthstarHubComp initialTrack='venture' />
}

export default StartupCornerComp
